import type { DirectiveBinding } from 'vue'
import auth from '@/services/permission/auth'


// <button v-permission="'user:add'">新增用户</button>
// <button v-permission="{ role: 'admin' }">管理员按钮</button>

const permissionDirective = {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
        const { value } = binding

        if (!value) {
            throw new Error(`v-permission 指令需要传值，比如 v-permission="'user:add'"、v-permission="['user:add']" 或 v-permission="{ permission: 'user:add', role: 'admin' }"`)
        }

        let hasPermission = false

        if (typeof value === 'string') {
            // 单个权限
            hasPermission = auth.hasPermi(value)
        } else if (Array.isArray(value)) {
            // 权限数组，任意一个满足
            hasPermission = auth.hasPermiOr(value)
        } else if (typeof value === 'object') {
            // 传的是对象，支持 { permission, role }
            const { permission, role } = value

            if (permission && role) {
                hasPermission = auth.hasPermi(permission) || auth.hasRole(role)
            } else if (permission) {
                hasPermission = auth.hasPermi(permission)
            } else if (role) {
                hasPermission = auth.hasRole(role)
            } else {
                console.error('v-permission 对象参数必须包含 permission 或 role')
            }
        } else {
            throw new Error(`v-permission 的参数格式必须是 string、array 或 object，当前是 ${typeof value}`)
        }

        if (!hasPermission) {
            el.style.display = 'none'
        }
    }
}

export default permissionDirective
